<!--
 * @Date: 2022-12-08 19:31:07
 * @LastEditTime: 2022-12-12 14:24:12
 * @Description: file content
-->
<template>
  <div class="slide-up">
    <img
      class="arrow"
      src="https://resource.chunyu.mobi/@/media/images/2022/12/08/7f9a/80d71ad6e28d_w146_h105_.png"
      alt=""
    />
    <div v-if="showArrow">
      <img
        class="arrow-long"
        src="https://resource.chunyu.mobi/@/media/images/2022/12/08/e351/e33ca9bc0797_w32_h164_.png"
        alt=""
      />
      <img
        class="hand"
        src="https://resource.chunyu.mobi/@/media/images/2022/12/08/4cfa/dab6a93cec1f_w134_h120_.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showArrow: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
img {
  display: block;
  &.arrow {
    width: rem(27);
    animation-name: move;
    animation-duration: 1s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    // animation-fill-mode: forwards;
    @keyframes move {
      100% {
        transform: translateY(-80%);
      }
      0% {
        transform: translateY(0);
      }
      // 100% {
      //   transform: translateY(-100%);
      // }
    }
  }
  &.arrow-long {
    width: rem(6);
  }
  &.hand {
    position: absolute;
    bottom: 0;
    left: 70%;
    width: rem(25);
  }
}
.slide-up {
  div {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: rem(3);
  }
}
</style>
